import React from 'react'
import { Megaphone } from 'lucide-react'

const MOCK = `<p>Minimum age for participation is 5 years. Guests with mobility limitations should contact us in advance so we can make suitable arrangements. The itinerary is subject to change due to weather conditions or force majeure; the captain reserves the right to alter the route for safety. All activities are weather-dependent. Check-in is at 12:00 noon; check-out by 10:00 AM on the final day.</p>`

export default function Notes({ content }) {
  const html = content || MOCK

  return (
    <section className="si-section si-section--last">
      <div className="si-notes__header">
        <Megaphone size={18} strokeWidth={1.5} />
        <h2 className="ljn-section-title" style={{ marginBottom: 0 }}>Important Notes</h2>
      </div>
      <div className="ljn-divider" style={{ marginBottom: 28 }} />
      <div className="si-prose si-notes__body" dangerouslySetInnerHTML={{ __html: html }} />
    </section>
  )
}
